import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useMediaQuery } from 'react-responsive';
import Header from '../header/index';
import Footer from '../footer/index';
import FooterAppBar from './../mobile-app-bar/index';

import '../../../sass/style.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/Fonts/futura/stylesheet.css';
import '../../assets/Fonts/futura-new/stylesheet.css';
// import "../../assets/Fonts/New-Futura/stylesheet.css";
import './index.css';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 });

  return isDesktop ? children : null;
};

const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ maxWidth: 991 });

  return isTablet ? children : null;
};

const TemplateWrapper = ({ children }) => (
  <div
    style={{
      background: 'var(--bg)',
      transition: 'color 0.2s ease-out, background 0.2s ease-out',
    }}>
    <Helmet title="Tau Chain Fan Site" />
    <Header />
    {children}

    <Footer />

    <Tablet>
      <FooterAppBar />
    </Tablet>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default TemplateWrapper;
